import React, { useState, useRef, useEffect } from 'react';

const DatePicker = ({ value, onChange, label, id }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [formattedDate, setFormattedDate] = useState('');
  const inputRef = useRef(null);

  // Update internal state when external value changes
  useEffect(() => {
    setInputValue(value || '');
    updateFormattedDate(value);
  }, [value]);

  // Format date for display
  const updateFormattedDate = (dateString) => {
    if (!dateString) {
      setFormattedDate('');
      return;
    }

    try {
      // Ensure date is in a consistent format
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const formatted = date.toLocaleDateString('en-US', { 
          month: 'long', 
          day: 'numeric', 
          year: 'numeric' 
        });
        setFormattedDate(formatted);
      } else {
        setFormattedDate('');
      }
    } catch (error) {
      console.error('Error formatting date:', error);
      setFormattedDate('');
    }
  };

  const handleDateChange = (e) => {
    const rawValue = e.target.value;
    
    // Update input value
    setInputValue(rawValue);
    
    // Update formatted display
    updateFormattedDate(rawValue);
    
    // Notify parent of change
    if (onChange) {
      onChange(rawValue);
    }
  };

  const clearDate = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    // Clear all states
    setInputValue('');
    setFormattedDate('');
    
    // Notify parent
    if (onChange) {
      onChange('');
    }
    
    // Focus back on input
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="date-picker-container">
      {label && <label htmlFor={id || 'date-picker'}>{label}</label>}
      
      <div className="date-input-wrapper">
        <input
          type="date"
          id={id || 'date-picker'}
          ref={inputRef}
          value={inputValue}
          onChange={handleDateChange}
          className="date-input"
        />
        
        {inputValue && (
          <button 
            type="button"
            className="clear-date-button"
            onClick={clearDate}
            aria-label="Clear date"
          >
            ×
          </button>
        )}
      </div>
      
      {/* {formattedDate && (
        <div className="selected-date-display">
          {formattedDate}
        </div>
      )} */}
    </div>
  );
};

export default DatePicker;